<app-mobile-household-header></app-mobile-household-header>
<mat-toolbar>
  <span class="color-primary">{{ "Guidelines" | translate }}</span>
</mat-toolbar>
<ng-container *ngIf="decisionService.allDecisions.length > 0">
  <ng-container *ngFor="let d of decisionService.allDecisions">
    <ng-container
      *ngIf="
        (d | hasCompletedPathways) === true;
        then showHasPathways;
        else showNoPathways
      "
    ></ng-container>
    <ng-template #showHasPathways>
      <mat-card mat-ripple class="mat-card touch" (click)="showDisclaimer(d)">
        <app-mobile-guideline
          [guideline]="d"
          [languages]="dataStoreService.languages$ | async"
        ></app-mobile-guideline>
      </mat-card>
    </ng-template>
    <ng-template #showNoPathways>
      <mat-card class="mat-card not-touch">
        <app-mobile-guideline
          [guideline]="d"
          [languages]="dataStoreService.languages$ | async"
        ></app-mobile-guideline>
      </mat-card>
    </ng-template>
  </ng-container>
</ng-container>
<br />
